const { DateTime } = require("luxon");

const { fetchCollection } = require("../firebase");
const { CUSTOMER_STATUS } = require("../constants");

const quotedTimes = [
  2, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 75, 90, 105, 120, 135, 150,
  165, 180,
];

const sort = (a, b) => a.arrivalTime.toDate() - b.arrivalTime.toDate();

// Round our quoted time to one of the valid quoted times
function round(x) {
  const quoted = quotedTimes.find((num) => num > x) || 180;
  return quoted;
}

function getActualWait(entry) {
  if (!entry || !entry.arrivalTime) return 0;
  const now = DateTime.local();
  const arrival = DateTime.fromJSDate(entry.arrivalTime.toDate());
  const diff = now.diff(arrival, ["minutes"]);
  const minutesWaited = diff.minutes;
  return minutesWaited;
}

const finishedStatuses = [
  CUSTOMER_STATUS.SEATED,
  CUSTOMER_STATUS.PARTIALLY_SEATED,
  CUSTOMER_STATUS.COMPLETED,
  CUSTOMER_STATUS.REMOVED,
  CUSTOMER_STATUS.DELETED,
];

async function getEstimatedWait(firebase, businessUid) {
  let waitlist = await fetchCollection(
    firebase,
    `waitlist/business/${businessUid}`
  );
  waitlist = waitlist.sort(sort);
  waitlist = waitlist.filter((el) => !finishedStatuses.includes(el.status));
  if (waitlist.length === 0) return 2;
  const topEntry = waitlist[0];
  const actualWait = getActualWait(topEntry);
  if (waitlist.length > 0 && actualWait === 0) return 5; //When you have people that just joined but haven't waited one min yet
  return round(actualWait);
}

module.exports = getEstimatedWait;
